import React from 'react';
import { connect } from 'react-redux';
import ErrorDialog from './ErrorDialog';
import ConfirmDialog from './ConfirmDialog';
import CampaignInfoDialog from './CampaignInfoDialog';
import SetToneNumberDialog from './SetToneNumberDialog';
import StopScreenDialog from './StopScreenDialog';
import SetChannelEventNameDialog from './SetChannelEventNameDialog';
import PackageErrorsDialog from './PackageErrorsDialog';
import KeyManagement from 'containers/Modal/KeyManagement';

const MODAL_DIALOGS = {
  error: ErrorDialog,
  confirm: ConfirmDialog,
  campaignInfo: CampaignInfoDialog,
  setToneNumber: SetToneNumberDialog,
  setChannelEventNameDialog: SetChannelEventNameDialog,
  packageErrors: PackageErrorsDialog,
  keyManagement: KeyManagement,
  stopScreens: StopScreenDialog,
};

export const ModalRoot = ({ modalType, modalProps }) => {
  if (!modalType) {
    return <span />;
  }

  const Modal = MODAL_DIALOGS[modalType];
  return <Modal {...modalProps} />;
};

export default connect(state => state.modal)(ModalRoot);
